/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { makeApi, URLS } from "Utils/apiURL";
import { notifyOpener } from "./oauthPopupBridge";
import reconnectSequencePopupState from "../settings/ConnectInbox/ReconnectSequencePopupState";

const GoogleOAuth = observer(() => {
  const [isConnected, setConnected] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const getAuthCode = () => {
    try {
      const url = new URL(window.location.href);
      const code = url?.searchParams.get("code");
      !code
        ? url?.href?.indexOf("access_denied") !== -1
          ? closeWindow()
          : ""
        : "";
      return code;
    } catch (e) {
      closeWindow();
      return null;
    }
  };

  const getAuthState = () => {
    try {
      const url = new URL(window.location.href);
      const state = url?.searchParams.get("state");
      return state;
    } catch (e) {
      closeWindow();
      return null;
    }
  };

  const connectGoogleApp = async () => {
    let resCode = "";
    let responseInboxId = "";
    let connectedInbox = {};
    let inboxId = "";

    try {
      const code = getAuthCode();
      const state = getAuthState();
      if (state) {
        inboxId = state?.split("_")?.pop();
      }
      if (!code) {
        setErrorMsg("No authorization code in callback URL");
        return;
      }

      let reconnectParam = state?.includes("reconnectInbox")
        ? `&reconnectInboxId=${inboxId}`
        : "";
      let apiUrlParam = state?.toLowerCase()?.includes("calendar")
        ? URLS.connectCalendar
        : URLS.connectGauth;
      const config = {
        url: `${apiUrlParam}?code=${code}${reconnectParam}`,
        method: "GET"
      };
      const res = await makeApi(config);
      const responseData = res?.data;

      if (responseData != null && Object.keys(responseData).length > 0) {
        const dataValue = responseData?.data || "";
        resCode = dataValue?.toString() || "";
        responseInboxId = responseData?.inboxId || "";
        connectedInbox = responseData?.inbox || {};
      }

      if (resCode !== "200") {
        const errText =
          (responseData && (responseData.message || responseData.error)) ||
          (res?.response?.status ? `HTTP ${res.response.status}` : "Connection failed");
        setErrorMsg(typeof errText === "string" ? errText : "Connection failed");
      } else if (inboxId) {
        // Fire-and-forget domain health refresh.
        makeApi({ url: `${URLS.getDomainHealth}?inboxId=${inboxId}`, method: "GET" });
      }
    } catch (err) {
      setErrorMsg(err?.message || "Unexpected error during connection");
    } finally {
      // Always notify the parent so its loading state clears, even on error.
      notifyOpener({
        code: resCode,
        type: "GOOGLE_CONNECT_INBOX",
        inboxId: responseInboxId,
        connectedInbox: connectedInbox
      });
      if (resCode === "200") {
        setConnected(true);
        setTimeout(closeWindow, 1000);
      } else {
        // Leave the popup open briefly so the user can read the error,
        // then close. Skip auto-close if we surfaced an error so the user can copy.
        setTimeout(closeWindow, errorMsg ? 8000 : 1500);
      }
    }
  };

  const closeWindow = () => {
    window?.close();
  };

  useEffect(() => {
    connectGoogleApp();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          {isConnected ? (
            <div>
              <span>Successfully Connected</span>
            </div>
          ) : errorMsg ? (
            <div>
              <div style={{ color: "#dc2626", fontWeight: 600 }}>Connection failed</div>
              <div style={{ marginTop: "10px", color: "#6b7280" }}>{errorMsg}</div>
              <div style={{ marginTop: "10px", fontSize: "12px", color: "#6b7280" }}>
                This window will close shortly.
              </div>
            </div>
          ) : (
            <div>
              <div>Please wait while we connect your google account</div>
              <div style={{ marginTop: "10px" }}> Connecting... </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default GoogleOAuth;
export { GoogleOAuth };
